/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useAuth } from '../../../../app/components/AuthProvider'

const HeaderUserMenu: FC = () => {
  const { user: { field_full_name } } = useAuth()

  const history = useHistory()

  const logoutUser = () => {
    localStorage.clear()
    history.push('/')
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5 px-5'>
              { field_full_name }
            </div>
          </div>
        </div>
      </div>

      <div className='menu-item px-5 my-1'>
        <Link to='/profile' className='menu-link px-5'>
          Profile
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a href="#" onClick={logoutUser} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
